import { messages } from 'i18n';
import useEmailEditorActions from 'broker/components/EmailEditor/store/useEmailEditorActions';
import useEmailEditorState from 'broker/components/EmailEditor/store/useEmailEditorState';
import TeammatesCcGroupContacts from 'broker/components/TeammatesCcGroupContacts';

export const BccField = () => {
  const {
    bcc: { availableTeammates, selectedTeammates },
  } = useEmailEditorState();

  const {
    bcc: { toggleTeammateSelection },
  } = useEmailEditorActions();

  return (
    <TeammatesCcGroupContacts
      teammates={availableTeammates}
      selectedTeammates={selectedTeammates}
      toggleTeammate={toggleTeammateSelection}
      spacingBottom={0}
      label={messages.emailEditor.bcc}
    />
  );
};
